import { isIe } from '../../../../util/detect'

export default class Mutators
{
    constructor(settings)
    {
        this._settings = settings;
    }

    initialize(store)
    {
        this._store = store;
    }

    get isMinimized() {
        const { Base, IsMinimized } = this._settings.stateLocations.Window;
        return this._store.getState()[Base][IsMinimized];
    }

    get isTablet() {
        const { DeviceType } = this._settings.stateLocations;
        const { tablet } = this._settings.mobileConstants.deviceTypes;
        return this._store.getState()[DeviceType] === tablet;
    }

    get className() {
        const { 
            launchPointContainer, 
            launchPointContainerTablet 
        } = this._settings.classNames;

        const className = this.isTablet ? 
            launchPointContainerTablet : 
            launchPointContainer;

        return className;
    }

    getMutate() {
        const style = isIe ? undefined : "";
        return (parameters) => {
            if (!this.isMinimized) {
                return parameters;
            }

            const newParams = {
                className: this.className,
                style
            };

            return Object.assign({}, parameters, newParams);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-launch/src/renderers/mutator.js